(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"]) return;
  try {
    
  $('.accordion .accordion-trigger').click(function() {
    var that = this;
    // Check if this section is already open
    var isOpen = $(this).parent().find('.accordion-section--content').is(":visible");
    // Close all sections
    $('.accordion .accordion-section--content').slideUp(400);
    $('.accordion .accordion-trigger').removeClass('active');
    // Open clicked section if it wasn't already open
    if (!isOpen) {
      $(this).parent().find('.accordion-section--content').slideDown(400);
      $(this).addClass('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $('.accordion .accordion-trigger').click(function() {
    var that = this;
    // Check if this section is already open
    var isOpen = $(this).parent().find('.accordion-section--content').is(":visible");
    // Close all sections
    $('.accordion .accordion-section--content').slideUp(400);
    $('.accordion .accordion-trigger').removeClass('active');
    // Open clicked section if it wasn't already open
    if (!isOpen) {
      $(this).parent().find('.accordion-section--content').slideDown(400);
      $(this).addClass('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-artists"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function() {
    
    const searchInput = document.getElementById("artist-search");
    const clearButton = document.getElementById("clear-search");
    const artistItems = document.querySelectorAll(".artists-grid--item");
  
    // Function to filter artists based on search input
    const filterArtists = () => {
      const searchText = searchInput.value.toLowerCase();
      
      // Show/hide clear button based on input
      clearButton.style.display = searchText ? "block" : "none";
  
      // Show/hide artists based on search
      artistItems.forEach(item => {
        const artistName = item.querySelector("h2").textContent.toLowerCase();
        item.style.display = artistName.includes(searchText) ? "block" : "none";
      });
    };
  
    // Attach event listeners
    searchInput.addEventListener("input", filterArtists);
  
    // Clear search input and show all artists when clear button is clicked
    clearButton.addEventListener("click", () => {
      searchInput.value = "";
      filterArtists();
    });

    const displaySwitcher = document.querySelector(".display-switcher");
    const gridViewBtn = displaySwitcher.querySelector(".grid-view");
    const listViewBtn = displaySwitcher.querySelector(".list-view");
    const artistsPage = document.querySelector(".artists-page");
  
    // Function to switch active state and view class
    const switchView = (view) => {
      // Remove active class from both and add to the clicked one
      gridViewBtn.classList.remove("active");
      listViewBtn.classList.remove("active");
  
      if (view === "grid") {
        gridViewBtn.classList.add("active");
        artistsPage.classList.add("show-grid");
        artistsPage.classList.remove("show-list");
      } else {
        listViewBtn.classList.add("active");
        artistsPage.classList.add("show-list");
        artistsPage.classList.remove("show-grid");
      }
    };
  
    // Event listeners for click
    gridViewBtn.addEventListener("click", () => switchView("grid"));
    listViewBtn.addEventListener("click", () => switchView("list"));

    document.querySelectorAll(".artists-list a").forEach(anchor => {
      anchor.addEventListener("mouseenter", function() {
        let imgSrc = this.getAttribute("data-img");
        document.querySelector(".artists-list--img img").setAttribute("src", imgSrc);
        document.querySelector(".artists-list--img img").classList.add("active");
      });
    });
    
    // Handle the mouseleave event on .featured-artists--list a elements
    document.querySelectorAll(".artists-list a").forEach(anchor => {
      anchor.addEventListener("mouseleave", function() {
        document.querySelector(".artists-list--img img").classList.remove("active");
      });
    });
    
  });


  } catch(e) { console.error(e); }
})();
})();
